export const GET_TOKENS_SUCCESS = 'GET_TOKENS_SUCCESS';
